import { getMostImportantTutorial } from "@/utils/apis/order-service";
import { useAuthStore } from "@/utils/stores/useAuthStore";
import { useTutorialStore } from "@/utils/stores/useTutorialStore";
import { useCallback, useState } from "react";

export const useGetTutorial = () => {
    const { auth } = useAuthStore();
    const { updateTutorial } = useTutorialStore();
    const [isLoading, setIsLoading] = useState(false);

    const fetchTutorial = useCallback(async () => {
        const { userId, idToken } = auth;
        if (!userId || !idToken) return;

        try {
            setIsLoading(true);
            const tutorial = await getMostImportantTutorial(userId, idToken);
            if (tutorial) {
                updateTutorial({ tutorial });
            }
        } catch (error) {
            console.error("Error fetching tutorial:", error);
        } finally {
            setIsLoading(false);
        }
    }, [auth, updateTutorial]);

    return {
        fetchTutorial,
        isLoading,
    };
}